import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ShieldAlert, Mail } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';

export default function AccessDenied() {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const email = params.get('email') || '';

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 via-white to-red-50 px-4">
      <Card className="w-full max-w-md p-8 shadow-xl border border-slate-200">
        <div className="flex flex-col items-center text-center">
          <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center mb-4">
            <ShieldAlert className="w-8 h-8 text-red-600" />
          </div>
          <h1 className="text-2xl font-bold text-slate-900">Access Denied</h1>
          <p className="text-slate-600 text-sm mt-2 leading-relaxed">
            {email ? (
              <>
                The email <span className="font-mono text-slate-800">{email}</span> is not
                authorized to access Eagle Academy WPK8.
              </>
            ) : (
              <>Your email is not authorized to access Eagle Academy WPK8.</>
            )}
          </p>

          <div className="w-full mt-6 p-4 rounded-lg bg-slate-50 border border-slate-200 text-left">
            <p className="text-xs font-semibold text-slate-700 uppercase tracking-wide mb-2">
              Who can sign in?
            </p>
            <ul className="text-sm text-slate-600 space-y-1.5">
              <li className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-blue-500"></span>
                <span>
                  Staff with an <span className="font-mono">@iltexas.org</span> email
                </span>
              </li>
              <li className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-green-500"></span>
                <span>
                  Students with an <span className="font-mono">@iltexasstudent.org</span> email
                </span>
              </li>
            </ul>
          </div>

          <div className="w-full mt-4 p-3 rounded-lg bg-blue-50 border border-blue-200 flex items-start gap-2">
            <Mail className="w-4 h-4 text-blue-600 flex-shrink-0 mt-0.5" />
            <p className="text-xs text-blue-900 text-left leading-relaxed">
              Need access? Contact your administrator at{' '}
              <a
                href="mailto:csteele@iltexas.org"
                className="font-medium underline hover:text-blue-700"
              >
                csteele@iltexas.org
              </a>
            </p>
          </div>

          <Button
            onClick={() => navigate('/login', { replace: true })}
            className="w-full mt-6 h-11 bg-slate-900 hover:bg-slate-800 text-white"
          >
            Back to Sign In
          </Button>
        </div>
      </Card>
    </div>
  );
}
